import { type HumanTaskBlockFormFieldsProps } from './types';
import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';

export function HumanTaskReadOnlyValueBlockFormFields(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <>
      <BlockValueTemplateField label="Field label" fieldName={`${fieldNamePrefix}.label`} />
      <BlockValueTemplateField label="Inbound data" fieldName={`${fieldNamePrefix}.value`} />
    </>
  );
}
